import { createCommand } from '../../utils';
import { SelectRoadSectionsCommand } from './SelectRoadSectionsCommand';

// Closing the right panel also drops the selection, so the map and the status bar stop showing it.
export const CloseRightPanelCommand = createCommand('MAP_V2/CLOSE_RIGHT_PANEL', async (_, { dispatch }) => {
    await dispatch(SelectRoadSectionsCommand({ ids: [] }));
});
